import { HTTP_CP_SmartSearch } from '@api-new/mortgageservice';
import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import {
  addSmartSearchSuccess,
  closeSmartSearchSuccess,
  getSmartSearches,
  getSmartSearchesFailure,
  getSmartSearchesSuccess,
  updateSmartSearchSuccess,
} from '@shared/store/smart-searches/smart-searches.actions';
import { SmartSearchesState } from '@shared/store/smart-searches/smart-searches.state';

export const getSmartSearchById = (smartSearch: Pick<HTTP_CP_SmartSearch, 'id'>): string => smartSearch.id;

export const smartSearchesAdapter: EntityAdapter<HTTP_CP_SmartSearch> = createEntityAdapter<HTTP_CP_SmartSearch>({
  selectId: getSmartSearchById,
});

export const smartSearchesInitialState: SmartSearchesState = smartSearchesAdapter.getInitialState({
  loading: true,
  pagination: { pageSize: 5, pageNumber: 1, totalCount: null, totalPages: null },
  errors: null,
});

const reducer = createReducer(
  smartSearchesInitialState,

  on(getSmartSearches, (state) => ({
    ...state,
    loading: true,
  })),

  on(getSmartSearchesSuccess, (state, smartSearchesResponse) =>
    smartSearchesAdapter.setAll(smartSearchesResponse.smartSearches ? smartSearchesResponse.smartSearches : [], {
      ...state,
      loading: false,
      errors: null,
    }),
  ),

  on(getSmartSearchesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    errors: error,
  })),

  on(addSmartSearchSuccess, (state, { smartSearch }) => smartSearchesAdapter.addOne(smartSearch, state)),

  on(updateSmartSearchSuccess, (state, { smartSearch }) => smartSearchesAdapter.setOne(smartSearch, state)),

  on(closeSmartSearchSuccess, (state, { smartSearchId }) => smartSearchesAdapter.removeOne(smartSearchId, state)),
);

export const smartSearchesReducer = (state: SmartSearchesState = smartSearchesInitialState, action: Action): SmartSearchesState =>
  reducer(state, action);
